
/**
 * OrderByRequest (launch-from-PR) constants. The reducer `actions`, the
 * bidding-type `types`, the `complexTypes` and the `File` shape are byte-identical
 * to the RFQ builder's, so they are re-exported from `Order/orderConstants` (the
 * shared source of truth) rather than duplicated here.
 *
 * Only two things legitimately differ and stay local:
 *  - `initialState` — the launch flow seeds `name: ""` and omits `internalCode`
 *    (the opposite of the RFQ builder). Unifying these would silently change the
 *    submitted payload (`buildOrderPayload` falls back `generalBidData.name ?? mat.name`),
 *    so they are kept per-flow on purpose (T6 ruling: CREATE CONTRACT).
 *  - `WIZARD_STEPS` — this flow has NO material-selection step (materials are
 *    prefilled from the PR items), so step 2 is supplier selection.
 */
export { actions, types, complexTypes } from "../Order/orderConstants";
export type { File } from "../Order/orderConstants";

export const initialState = {
  paymentMethod: "",
  paymentTerm: "",
  startDateValue: "",
  startTimeValue: "",
  finishDate: "",
  endTimeValue: "",
  consultationStartValue: "",
  consultationEndValue: "",
  expireDate: false,
  buyerPicksUp: false,
  name: "",
  comment: "",
  incoTerm: "DAP",
  currency: "",
  files: [] as { fileName: string; type: string; fileURL: string }[],
};

export const WIZARD_STEPS: { id: number; labelKey: string }[] = [
  { id: 1, labelKey: "tenders.biddingType" },
  { id: 2, labelKey: "tenders.selectSuppliers" },
  { id: 3, labelKey: "tenders.priceAndPayment" },
  { id: 4, labelKey: "tenders.generalData" },
  { id: 5, labelKey: "tenders.summary" },
];
